import React, { useEffect, useState } from "react";
import { Box, Fab, Zoom } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { openWhatsApp } from "../../utils/constants";

const BackToTop = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 280);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        right: 24,
        bottom: 24,
        zIndex: 1300,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
      }}
    >
      <Fab
        onClick={openWhatsApp}
        aria-label="chat on whatsapp"
        sx={{
          bgcolor: "#25D366",
          color: "white",
          "&:hover": { bgcolor: "#1faf57" },
        }}
      >
        <FontAwesomeIcon icon={faWhatsapp} />
      </Fab>

      <Zoom in={showTop}>
        <Fab
          aria-label="back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          sx={{
            background: "linear-gradient(135deg, #2563eb, #7c3aed)",
            color: "white",
            "&:hover": {
              background: "linear-gradient(135deg, #1d4ed8, #6d28d9)",
            },
          }}
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </Fab>
      </Zoom>
    </Box>
  );
};

export default BackToTop;
